import { defineAsyncComponent } from 'vue';

export default {
	description: "Роли",
	forms: {
		edit: {
			panel: {
				// height: '280px',
				width: '70%'
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		}
	}
}